import { inject, Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { getDowntimeMessageQuery } from '../../../queries/account/downtime.queries';
import { map } from 'rxjs/operators';
import { SKIP_AUTH } from '../../interceptors/auth.interceptor';

@Injectable({
  providedIn: 'root',
})
export class DowntimeFacade {
  #apollo = inject(Apollo);

  public getDowntimeMessage() {
    return this.#apollo
      .query<{
        downtimeMessage: {
          downtimeMessage: string;
        };
      }>({
        query: getDowntimeMessageQuery,
        context: { httpContext: new HttpContext().set(SKIP_AUTH, true) },
      })
      .pipe(map(response => response?.data?.downtimeMessage));
  }
}
